import { DialogContent, DialogTitle, Divider, Slide, Stack, Typography } from '@mui/material';
import { TransitionProps } from '@mui/material/transitions';
import React, { forwardRef } from 'react';
import AquantCancelIcon from '../resources/images/aq-cancel.svg';
import DateSelectionForm from './DateSelectionForm';
import SiDialog from './SiDialog';

type Props = {
    open: boolean;
    onClose: Function;
    onSubmit: (startDate, endDate, isPartial) => void;
    actionTitle: string;
    actionDescription: string;
    config?: any;
};

const Transition = forwardRef(
    (
        props: TransitionProps & {
            children: React.ReactElement;
        },
        ref: React.Ref<unknown>,
    ) => <Slide direction="up" ref={ref} {...props} />,
);

const DateSelectionDialog = (props: Props) => (
    <SiDialog open={props.open} onClose={() => props.onClose()} TransitionComponent={Transition}>
        <DialogTitle>
            <Stack className="DialogTitle">
                <Typography className="DialogTitleText">{props.actionTitle}</Typography>
                <img src={AquantCancelIcon} onClick={() => props.onClose()} alt="cancel icon" className="CancelIcon" />
            </Stack>
        </DialogTitle>
        <Divider />
        <DialogContent classes={{ root: 'DialogContent' }}>
            <Typography
                style={{ color: '#4A4A4A' }}
                fontWeight={500}
                letterSpacing="0.04em"
                lineHeight="140%"
                fontSize="16px"
                marginBottom="9px"
            >{`Set desired time frame for ${props.actionTitle.toLowerCase()}:`}</Typography>
            <DateSelectionForm
                onSubmit={(startDate: any, endDate: any, isPartial: boolean) =>
                    props.onSubmit(startDate, endDate, isPartial)
                }
                onCancel={() => props.onClose()}
                actionTitle={props.actionTitle}
                actionDescription={props.actionDescription}
                config={props.config}
            />
        </DialogContent>
    </SiDialog>
);

export default DateSelectionDialog;
